import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import localeFr from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeFr);

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ErrorInterceptor } from './Helper/ErrorInterceptor';
import { JwtInterceptor } from './Helper/JwtInterceptor';
//COMPONENTS
import { MaincomponentComponent } from './components/maincomponent/maincomponent.component';
import { LoginComponent } from './components/login/login.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { LoadConfigurationComponent } from './components/load-configuration/load-configuration.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { LoadConfigurationDetailComponent } from './components/load-configuration-detail/load-configuration-detail.component';
import { DialogDeleteShipComponent } from './components/dialogs/dialog-delete-ship/dialog-delete-ship.component';
import { DialogMoveShipComponent } from './components/dialogs/dialog-move-ship/dialog-move-ship.component';
import { UploadFileComponent, LoadDetailModal, LoadPdfModal } from './components/upload-file/upload-file.component';
import { MessageComponent } from './utilities/mesagge/message.component';
import {OrdersComponent} from './components/orders/orders.component';
import { DialogShowItemsComponent } from './components/dialogs/dialog-show-items/dialog-show-items.component';
import { DialogShowStatusComponent } from './components/dialogs/dialog-show-status/dialog-show-status.component';
import { DialogStartIterateComponent } from './components/dialogs/dialog-start-iterate/dialog-start-iterate.component';
//SERVICES
import { ApiService } from './core/services/api.service';
import { LocalStorageService } from './core/services/local-storage.service';
import { LocalStorage } from './core/services/local-storage';
import { WindowRef } from './core/services/window';
import { LogisticModule } from './components/logistic/logistic.module';
import { MessageService } from './core/services/message.service';


import { ClientAddressMapComponent } from './components/client-address-map/client-address-map.component';
import { MapModule } from './components/map/map.module';
import { GenericModalComponent } from './components/logistic/generics/modal/generic-modal.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ChartsModule } from 'ng2-charts';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { FileDropModule } from 'ngx-file-drop';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { CustomLoader } from './utilities/translate/custom-loader';
import { TranslateSelectComponent } from './components/translate-select/translate-select.component';
import { NgxLanguageSelectorModule } from 'ngx-language-selector';
import { CustomersModule } from './components/customers/customers.module';
import { SharedModule } from './shared/shared.module';
import { NotificationBadgeComponent } from './components/notification-badge/notification-badge.component';
import { CatalogsModule } from './components/catalogs/catalogs.module';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { IdentityService } from './core/services/identity.service';
import { DialogShowJustificationsComponent } from './components/dialogs/dialog-show-justifications/dialog-show-justifications.component';
import { DialogShowContactsComponent } from './components/dialogs/dialog-show-contacts/dialog-show-contacts.component';
import { ConfigsModule } from './components/configs/configs.module';
import { JustificationModalComponent } from './components/logistic/generics/modal/justification-modal.component';
import { DialogOptimizeComponent } from './components/dialogs/dialog-optimize/dialog-optimize.component';
import { DialogPositionShipComponent } from './components/dialogs/dialog-position-ship/dialog-position-ship.component';
import { CoreModule } from './core/core.module';
import { MatExpansionModule, MatStepperModule } from '@angular/material';
import { UpdateAddressModalComponent } from './components/dialogs/dialog-update-address/dialog-update-address.component';
import { FindMatchService } from './core/services/find-match.service';
import { HomeModule } from './components/home/home.module';
import { ReportsComponent } from './components/reports/reports.component';
import { WarehouseModule } from './components/warehouse/warehouse.module';

@NgModule({
  declarations: [
    AppComponent,
    MaincomponentComponent,
    LoginComponent,
    SideNavComponent,
    ToolbarComponent,
    LoadConfigurationComponent,
    TicketsComponent,
    LoadConfigurationDetailComponent,
    DialogDeleteShipComponent,
    DialogMoveShipComponent,
    DialogShowJustificationsComponent,
    UploadFileComponent,
    ClientAddressMapComponent,
    MessageComponent,
    DialogShowItemsComponent,
    DialogShowStatusComponent,
    DialogStartIterateComponent,
    DialogShowContactsComponent,
    DialogOptimizeComponent,
    DialogPositionShipComponent,
    GenericModalComponent,
    TranslateSelectComponent,
    LoadDetailModal,
    LoadPdfModal,
    OrdersComponent,
    NotificationBadgeComponent,
    JustificationModalComponent,
    UpdateAddressModalComponent,
    ReportsComponent
  ],
  entryComponents: [DialogDeleteShipComponent, DialogMoveShipComponent, MessageComponent, DialogShowItemsComponent,
    DialogShowStatusComponent, DialogStartIterateComponent,OrdersComponent,GenericModalComponent, LoadDetailModal, LoadPdfModal, ConfirmDialogComponent,
    DialogShowJustificationsComponent, DialogShowContactsComponent, JustificationModalComponent, DialogOptimizeComponent,
    DialogPositionShipComponent, UpdateAddressModalComponent],
  imports: [
    AppRoutingModule,
    SharedModule,
    LogisticModule,
    MapModule,
    NgHttpLoaderModule,
    NgProgressModule.forRoot(),
    NgProgressHttpModule.forRoot(),
    FileDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader
      }
    }),
    NgxLanguageSelectorModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    CustomersModule,
    CatalogsModule,
    ConfigsModule,
    MatExpansionModule,
    MatStepperModule,
    HomeModule,
    WarehouseModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ApiService,
    LocalStorageService,
    LocalStorage,
    WindowRef,
    MessageService,
    IdentityService,
    FindMatchService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('es-Mx');
    translate.use('es-Mx');
  }
}
